import { Routes } from '@angular/router';

import { roleGuard } from '../../@core/authentication/guards/role.guard';
import { AccountType } from '../../@core/authentication/models/account-type.enum';
import { auditTrailRoutes } from '../audit-trail/audit-trail.routes';
import { batchProcessingRoutes } from '../batch-processing/batch-processing.routes';
import { customerDetailRoutes } from '../customer-detail/customer-detail.routes';
import { invoiceRoutes } from '../invoices/invoice.routes';
import { manageUsersRoutes } from '../manage-users/manage-users.routes';
import { profileRoutes } from '../profile/profile.routes';

/**
 * ADMIN-only routes. Default landing: admin-dashboard.
 */
export const adminRoleRoutes: Routes = [
  {
    path: 'admin',
    canActivate: [roleGuard(AccountType.ADMIN)],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../dashboard/pages/admin-dashboard/admin-dashboard').then(
                (m) => m.AdminDashboard,
              ),
          },
          {
            path: 'widgets/ews-triggers-trend',
            loadComponent: () =>
              import(
                '../dashboard/pages/admin-dashboard/pages/monthly-trigger-trend/monthly-trigger-trend'
              ).then((m) => m.MonthlyTriggerTrend),
          },
          {
            path: 'widgets/risk-distribution',
            loadComponent: () =>
              import(
                '../dashboard/pages/admin-dashboard/pages/risk-distribution-detail/risk-distribution-detail'
              ).then((m) => m.RiskDistributionDetail),
          },
          {
            path: 'widgets/trigger-status',
            loadComponent: () =>
              import(
                '../dashboard/pages/admin-dashboard/pages/trigger-movement-analysis/trigger-movement-analysis'
              ).then((m) => m.TriggerMovementAnalysis),
          },
          {
            path: 'widgets/branch-triggers',
            loadComponent: () =>
              import(
                '../dashboard/pages/admin-dashboard/pages/branch-analysis/branch-analysis'
              ).then((m) => m.BranchAnalysis),
          },
          {
            path: 'widgets/product-triggers',
            loadComponent: () =>
              import(
                '../dashboard/pages/admin-dashboard/pages/product-analytics/product-analytics'
              ).then((m) => m.ProductAnalytics),
          },
          {
            path: 'widgets/top-rules',
            loadComponent: () =>
              import(
                '../dashboard/pages/admin-dashboard/pages/rule-analytics/rule-analytics'
              ).then((m) => m.RuleAnalytics),
          },
          {
            path: 'widgets/high-risk-loan-segments',
            loadComponent: () =>
              import(
                '../dashboard/pages/admin-dashboard/pages/loan-segment-analysis-high-risk/loan-segment-analysis-high-risk'
              ).then((m) => m.LoanSegmentAnalysisHighRisk),
            data: { segmentTab: 'high' },
          },
          {
            path: 'widgets/mid-risk-loan-segments',
            loadComponent: () =>
              import(
                '../dashboard/pages/admin-dashboard/pages/loan-segment-analysis-high-risk/loan-segment-analysis-high-risk'
              ).then((m) => m.LoanSegmentAnalysisHighRisk),
            data: { segmentTab: 'mid' },
          },
          {
            path: 'widgets/exposure-summary',
            loadComponent: () =>
              import(
                '../dashboard/pages/admin-dashboard/pages/loan-segment-analysis-high-risk/loan-segment-analysis-high-risk'
              ).then((m) => m.LoanSegmentAnalysisHighRisk),
            data: { segmentTab: 'exposure' },
          },
          {
            path: 'widgets/:widgetId',
            loadComponent: () =>
              import(
                '../dashboard/pages/admin-dashboard/pages/admin-dashboard-widget-detail/admin-dashboard-widget-detail'
              ).then((m) => m.AdminDashboardWidgetDetail),
          },
        ],
      },
      ...auditTrailRoutes,
      ...batchProcessingRoutes,
      ...customerDetailRoutes,
      ...invoiceRoutes,
      ...manageUsersRoutes,
      ...profileRoutes,
    ],
  },
];
